import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ChangeTemplateRequestDto } from 'src/api/FiretrolApiClient';
import { changeTemplateApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';
import { queryKeys } from 'src/api/queries/queryKeys';

export function useCreateChangeTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (request: ChangeTemplateRequestDto) =>
      changeTemplateApiClient.create(request),
    meta: { successMessage: 'Template Created!' },
    onSettled: () => invalidateFor('changeTemplate.save', qc),
  });
}

export function useUpdateChangeTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      request,
    }: {
      id: string;
      request: ChangeTemplateRequestDto;
    }) => changeTemplateApiClient.update(id, request),
    meta: { successMessage: 'Template Updated!' },
    onSuccess: (result, { id }) =>
      qc.setQueryData(queryKeys.organization.changeTemplateDetail(id), result),
    onSettled: () => invalidateFor('changeTemplate.save', qc),
  });
}

export function useDeleteChangeTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => changeTemplateApiClient.delete(id),
    meta: {
      successMessage: 'Template Deleted!',
      errorContext: 'delete change template',
    },
    onSettled: () => invalidateFor('changeTemplate.save', qc),
  });
}
